import Header from '../../components/Header'
import Footer from '../../components/Footer'
import LoginForm from '../../components/LoginForm'

function Login() {
    return (
        <div>
            <Header></Header>
            <LoginForm></LoginForm>
            <Footer></Footer>
        </div>
    )
}

export default Login